import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            position: 'relative',
            display: 'grid',
            height: 'max-content',
            minHeight: '100%',
            maxHeight: '100%',
            gridTemplateRows: 'auto minmax(0, 1fr)',
            gridTemplateColumns: 'minmax(0px, 1fr)',
            gridTemplateAreas: '"header" "content"',
            rowGap: '1px'
        }
    }
})